
import * as types from './types';

export const drillUp = breadcrumbIndex => ({
  type: types.DRILL_UP,
  breadcrumbIndex,
});

export const selectCompareMode = (mode, scope, dimensionsSelectionMode) => ({
  type: types.SELECT_COMPARE_MODE,
  mode,
  scope,
  dimensionsSelectionMode,
});

export const resetDrillDown = drilldownData => ({
  type: types.RESET_DRILL_DOWN,
  drilldownData,
});
